import i18n, { intlLocaleFor } from '../i18n/config';

function numLocale(): string {
  return intlLocaleFor(i18n.language || 'vi');
}

export function formatCurrency(value: number, currency = 'USDT'): string {
  return `${value.toLocaleString(numLocale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
}

/** Целые VND с разделителями тысяч */
export function formatVndInt(value: number): string {
  if (!Number.isFinite(value)) return '—';
  return Math.round(value).toLocaleString(numLocale());
}
